var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (model) {pug_html = pug_html + "\u003Cdiv class=\"popover-titled-content__title\"\u003E";
if (model.title.isView) {
pug_html = pug_html + "\u003Cdiv data-ref=\"title\"\u003E\u003C\u002Fdiv\u003E";
}
else
if (model.title.html) {
pug_html = pug_html + (null == (pug_interp = model.title.html) ? "" : pug_interp);
}
else {
pug_html = pug_html + "\u003Cspan class=\"popover-title-content__title-text\"\u003E" + (pug.escape(null == (pug_interp = model.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"popover-titled-content__body\"\u003E";
if (model.body.isView) {
pug_html = pug_html + "\u003Cdiv data-ref=\"body\"\u003E\u003C\u002Fdiv\u003E";
}
else
if (model.body.html) {
pug_html = pug_html + (null == (pug_interp = model.body.html) ? "" : pug_interp);
}
else {
pug_html = pug_html + "\u003Cspan class=\"popover-title-content__body-text\"\u003E" + (pug.escape(null == (pug_interp = model.body) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined));;return pug_html;};
module.exports = template;